import {Injectable} from '@angular/core';
import {DtoBaseService} from "../../../../_services/dto-services/dto-base.service";
import {EmployeeDto} from "../../x-models/employee-dto";
import {EmployeeHttpService} from "../../x-http-requests/employee-http.service";
import {Observable} from 'rxjs';
import {GlobalAlertService} from "../../../../_services/global-alert.service";
import {DtoSignalRService} from "../../../../_services/dto-services/dto-signal-r.service";
import {DtoServices} from "../../../../_services/dto-services/_enums/dto-services";

@Injectable({
  providedIn: 'root'
})
export class EmployeeService extends DtoBaseService<EmployeeDto, EmployeeHttpService> {
  public Identifier: DtoServices = DtoServices.EmployeeService;

  Add(payload: any): Observable<EmployeeDto> {
    // The third argument used to be `sendPasswordReset: false` — #279 removed it, because creating an employee
    // mails nothing at all now. This DTO-cache path never passed an employment start or an address either, so it
    // stays the two-name minimum it always effectively was.
    return this.HttpService.add(payload.FirstName, payload.LastName)
  }

  FetchAll(all: boolean): Observable<EmployeeDto[]> {
    return this.HttpService.list("", all);
  }

  FetchById(id: string, all: boolean): Observable<EmployeeDto> {
    // Former-inclusive: a SignalR update for a just-ended employee must still resolve so caches don't go stale.
    return this.HttpService.get(id, true);
  }

  GetId(entity: EmployeeDto): string {
    return entity.id;
  }

  constructor(employeeHttpService: EmployeeHttpService, globalAlertService: GlobalAlertService, dtoSignalRService: DtoSignalRService) {
    super(employeeHttpService, globalAlertService, dtoSignalRService);
    this.Initialize();
  }

  FetchByRelationshipId(relationshipId: string, all: boolean): Observable<EmployeeDto[]> {
    return this.HttpService.list(relationshipId);
  }

  GetSelected(): EmployeeDto[] | undefined {
    return this.Entities?.filter(e => e.selected);
  }

  GetSelectedIds(): string[] | undefined {
    return this.GetSelected()?.map(x => x.id);
  }
}
